import React from 'react';

import { ListProps } from './list.types';
import { CategoriesList } from './categories-list';
import { useCategoriesList } from './use-categories-list';
import { LargeCard } from '../cards/large-card';

export const LargeList = ({ items, mobileDisplay, style, showHeading, gap }: ListProps): JSX.Element => {
  const { isExpanded, viewAllItems } = useCategoriesList();

  return (
    <CategoriesList
      mobileDisplay={mobileDisplay}
      itemCount={items.length}
      isExpanded={isExpanded}
      viewAllItems={viewAllItems}
      showHeading={showHeading}
      gap={gap}
    >
      {items.map(({ category, image }, index) => (
        <LargeCard
          key={category}
          category={category}
          image={image}
          radius={style}
          mobileDisplay={mobileDisplay}
          isHidden={!isExpanded && index > 5}
        />
      ))}
    </CategoriesList>
  );
};
